import { Add, Remove, ShoppingCart, Delete, DeleteForever, PublishedWithChanges } from "@mui/icons-material";
import {
  Badge,
  Button,
  Card,
  Grid,
  IconButton,
  styled,
  TextField,
  Drawer,
  CircularProgress,
  Checkbox,
  Tooltip,
  Container,
  Autocomplete,
  InputLabel,
} from "@mui/material";
import { Box } from "@mui/system";
import FsLightbox from "fslightbox-react";
import React, { useState, useEffect } from "react";
import { useCart } from "../Context/CartContext";
import httpclient from "../../utils";
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import SelectSchool from "../SelectSchool";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useParams } from 'react-router-dom';
import OptionDialog from "../OptionDialog";


const CustomDrawer = styled(Drawer)`
  .MuiDrawer-paper {
    min-width: 600px;
    height: 800px;
    padding: 20px 20px 20px 20px;
    margin-top: 80px;
    opacity: 1;
    overflow-y: auto,scroll;  /* Add this line to make the drawer scrollable */
  }
`;


const ItemsBox = styled(Box)(({ theme }) => ({
  // minWidth: "1200px",
  borderBottom: "1px solid #999",
  padding: "10px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down('md')]: {
    overflowX: "scroll",
    gap: "15px"
  },
}));
const ItemsBox1 = styled(Box)(({ theme }) => ({
  // minWidth: "800px",
  borderBottom: "1px solid #999",
  padding: "10px 0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down('md')]: {
    overflowX: "scroll",
    gap: "15px"
  },
}));


const ImageBox = styled(Box)(({ theme }) => ({
  marginRight: "20px",
  "& img": {
    width: "100px",
    height: "80px",
    objectFit: "contain",
    borderRadius: "10px",
  },
}));


const ProductCode = styled(Box)(({ theme }) => ({
  width: "120px",
  // marign: "0 10px",
}));

const ProductName = styled(Box)(({ theme }) => ({
  width: "310px",
  marign: "0 10px",
  "& small": {
    color: "grey",
    fontSize: "12px",
    lineHeight: "1.4",
  },
}));
const ProductName1 = styled(Box)(({ theme }) => ({
  width: "410px",
  // marign: "0 10px",
}));

const Cart = styled(Box)(({ theme }) => ({
  width: "610px",
  color: "#999",
  // marign: "0 10px",
}));

const ProductColor = styled(Box)(({ theme }) => ({
  width: "240px",
  color: "#999",
  // marign: "0 10px",
}));


const ProductPrice = styled(Box)(({ theme }) => ({
  width: "120px",
  // marign: "0 10px",
}));
const ProductPrice1 = styled(Box)(({ theme }) => ({
  width: "180px"
  //width:"250px"
}));

const ProductPrice2 = styled(Box)(({ theme }) => ({
  width: "335px",
  fontSize: "16px"
}));


const QuantityBox = styled(Box)(({ theme }) => ({
  width: "155px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));


const ProductSize = styled(Box)(({ theme }) => ({
  width: "160px",
  "& small": {
    color: "grey",
    fontSize: "12px",
    lineHeight: "1.4",
  },

  // marign: "0 10px",
}));

// const ButtonDiv = styled(Box)(({ theme }) => ({
//   marginLeft: "50px",
//   textAlign: "left",
//   width: "150px",
// }));

const ButtonDiv = styled(Box)(({ theme }) => ({
  marginLeft: "0px",
  textAlign: "right",
  width: "175px",
}));



const ProductPage = ({
  step,
  setStep,
  customerDetails,
  handleQuantity,
  handleAdd,
  handleSubstract,
  //handleOpenOptions,
  handleAddToCart,
  handleRemoveFromCart,
  handleReset,
  handleSaveCustomerDetails,
  handleSaveSalesOrder,
  handleUpdateSalesOrder,
  handleConfirmSalesOrder,
  openPaymentTypeDialog,
  handleFinish,
  keyLoading,
  keyLoading1,
  //loading,
  setKeyLoading,
  setKeyLoading1,
  express,
  setExpress,
  state,
  setState,
  payNow,
  setPayNow,
  trigger,
  setTrigger,
}) => {

  const cart = customerDetails.cart;
  const [cartOpen, setCartOpen] = useState(false);
  const [openViewOptions, setOpenViewOptions] = useState(false);
  const [viewOptionDetails, setViewOptionDetails] = useState([]);
  const [productslist, setProductslist] = useState([]);
  const [productslistFinal, setProductslistFinal] = useState([]);
  const [SOFList, setSOFList] = useState([]);
  const [SOFTemplate, setSOFTemplate] = useState("");
  const [SOFTemplate1, setSOFTemplate1] = useState("");
  const [loading, setLoading] = useState(false);
  const [singleLoading, setSingleLoading] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const [imageUrlsByCategory, setImageUrlsByCategory] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(Object.keys(imageUrlsByCategory)[0]);
  const { id } = useParams();
  let pos = id;

  const [toggler, setToggler] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  // const handleImageShow = (category, index) => {
  //   setSelectedCategory(category);
  //   setImageIndex(index);
  //   setToggler(!toggler);
  // };

  const handleImageShow = (category, index) => {
    if (category !== selectedCategory) {
      setImageIndex(index);
      setSelectedCategory(category);
      setToggler(false);
      setTimeout(() => setToggler(true), 100);
    } else {
      setImageIndex(index);
      setToggler(!toggler);
    }
  };
  
  const [toggler1, setToggler1] = useState(false);
  const [imageIndex1, setImageIndex1] = useState(0);

  const handleCartImageShow = (index) => {
    setToggler1(!toggler1);
    setImageIndex1(index);
  };

  const handleSwitchChange = () => {
    setExpress(!express); // Toggle the value of x when the switch is checked or unchecked
  };
  const handleCheckboxChange = () => {
    setPayNow(!payNow); // Toggle the value of x when the switch is checked or unchecked
  };


  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png";
  }


  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = () => {
    setLoading(true);
    httpclient.get(`getAllMatrix?posID=${pos}&schoolID=${customerDetails.schoolID}`).then(({ data }) => {
      if (data.status === 200) {
        setLoading(false);
        const productData = data.records;
        setProductslist(productData);
        const SOFData = data.SOF
        setSOFList(SOFData);
      } else {
        setLoading(false);
        //console.log("Error!");
      }
    });
  };

  useEffect(() => {
    groupByCategory(productslist);
  }, [productslist])

  const groupByCategory = (productList) => {
    const groupedProducts = {};

    productList.forEach(product => {
      const category = product.Category_Name;
      if (!groupedProducts[category]) {
        groupedProducts[category] = [];
      }
      groupedProducts[category].push(product);
    });

    return setProductslistFinal(groupedProducts);

  };

  const handleOpenOptions = (product) => {
    setOpenViewOptions(true);
    setSingleLoading(true);
    httpclient
      .get(`getAllMatrix?newapi=true&warehouseID=${pos}&WEBSKU=${product.WEBSKU}&ColourID=${product.ColourID}&version=v4`)
      .then(({ data }) => {
        if (data.status === 200) {
          // The API returns every colour for this WEBSKU (alphabetically), not just the
          // clicked one, so move the clicked colour's group to the front here — the dialog
          // always shows/opens on records[0].
          const records = [...data.records];
          const clickedIndex = records.findIndex(
            (group) => String(group[0]?.ColourID) === String(product.ColourID)
          );
          if (clickedIndex > 0) {
            const [clickedGroup] = records.splice(clickedIndex, 1);
            records.unshift(clickedGroup);
          }
          setViewOptionDetails(records);
          setSingleLoading(false);
        }
      })
  };


  const sendOption = (callback) => {
    if (callback.open === false) {
      setOpenViewOptions(false);
      setViewOptionDetails({});
    }
    if (callback.refetch === true) {
      handleOpenOptions(callback);
      setTimeout(() => {
        getProducts();
      }, 1000);
    }
  };


  //var productslist = productslist1.filter(product => customerDetails.schoolID?.includes(product.SchoolID));
  //console.log("productlist", productslist);


  const placeholderImageUrl = 'https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png';

  // const imageUrls = productslist.map((product) => {
  //   if (product.imageUrl) {
  //     return product.imageUrl;
  //   } else {
  //     return placeholderImageUrl;
  //   }
  // });

  useEffect(() => {
    const newImageUrlsByCategory = {};

    Object.keys(productslistFinal).forEach((category) => {
      const imageUrls = productslistFinal[category].map((product) => {
        return product.imageUrl ? product.imageUrl : placeholderImageUrl;
      });
      newImageUrlsByCategory[category] = imageUrls;
    });

    setImageUrlsByCategory(newImageUrlsByCategory);
  }, [productslistFinal]);

  const cartImageUrls = customerDetails.cartItems.map((cart) => {
    if (cart.imageUrl) {
      return cart.imageUrl;
    } else {
      return placeholderImageUrl;
    }
  });



  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsScrolled(scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const handleSOFChange = (value) => {
    const sofTemplateValue = value !== null ? value.SOFTemplate : "";
    setSOFTemplate(sofTemplateValue);
    if (sofTemplateValue !== "") {
      setSOFTemplate1(sofTemplateValue);
      setLoading(true);
      httpclient.get(`getAllMatrix?posID=${pos}&schoolID=${customerDetails.schoolID}&sofTemplate=${sofTemplateValue}`)
        .then(({ data }) => {
          if (data.status === 200) {
            setLoading(false);
            const productData = data.records;
            setProductslist(productData);
          } else {
            setLoading(false);
            console.error("error:", data.error);

          }
        })
        .catch((error) => {

          setLoading(false);
          console.error("error:", error);
        });
    }
  };


  const handleChangeSOF = (e) => {
    setSOFTemplate(e.target.value)
  };

  return (
    <div>
      <Card>
        <Box p={4}>
          <Box
            //mb={3}
            pb={3}
            display="flex"
            alignItems={"center"}
            flexDirection={"row"}
            justifyContent="space-between"
          >
            {state ? <h2> Cart Products</h2> : <h2>Products</h2>}

            {!state ? (
              <>
                <h4 style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}>
                  SOF :{" "}
                  <Autocomplete
                    disablePortal
                    inputValue={SOFTemplate}
                    options={SOFList.length > 0 ? SOFList : []}
                    getOptionLabel={(option) => option.SOFTemplate || null}
                    renderOption={(props, option, index) => { return <li {...props} key={option.SOFTemplate}>{option.SOFTemplate}</li> }}
                    sx={{ marginLeft: "10px", width: 300 }}
                    onChange={(event, newValue) => {
                      handleSOFChange(newValue);
                    }}
                    autoFocus
                    //onFocus={(e) => e.target.select()}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={SOFTemplate1 ? SOFTemplate1 : SOFList[0]?.SOFTemplate}
                        name="SOFTemplate"
                        value={SOFTemplate || ""}
                        onChange={handleChangeSOF}
                        fullWidth
                      />
                    )}
                  />
                </h4>
              </>
            ) : (
              ""
            )}


            <h4
              style={{
                position: isScrolled ? 'fixed' : 'static',
                top: isScrolled ? '40%' : 'auto',
                left: isScrolled ? '90%' : '0',
                zIndex: 100,
              }}>
              Cart{" "}
              <Badge
                badgeContent={customerDetails.cartItems.length}
                color="secondary"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >

                <ShoppingCart sx={{ cursor: "pointer" }} onClick={() => setCartOpen(true)} />
              </Badge>
            </h4>
          </Box>

          <Grid container spacing={2}>
            {!state ? (

              <FsLightbox
                toggler={toggler}
                key={selectedCategory}
                //sources={imageUrls}
                sources={imageUrlsByCategory[selectedCategory]}
                sourceIndex={imageIndex}
                type="image"
              />


            ) : (
              <FsLightbox
                toggler={toggler1}
                sources={cartImageUrls}
                sourceIndex={imageIndex1}
                type="image"

              />

            )}

            {!state ? (
              <>
                {loading ? (
                  <CircularProgress color="secondary" />
                ) : (
                  <>
                    {productslist.length > 0 ? (
                      <>
                        {Object.keys(productslistFinal).map((category) => (
                          <div style={{ width: "100%" }} key={category}>
                            <h4>{category}</h4>
                            {productslistFinal[category].length > 0 ? (
                              <Grid item xs={12}>
                                {productslistFinal[category].map((product, index) => (
                                  <ItemsBox key={product.id}>
                                    <ImageBox onClick={() => handleImageShow(category, index)}>
                                      {product.imageUrl ? (
                                        <img
                                          src={product.imageUrl}
                                          alt={product.ItemName}
                                          onError={handleImageError}
                                        />
                                      ) : (
                                        <img
                                          src="https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png"
                                          alt="Placeholder"
                                        />
                                      )}
                                    </ImageBox>

                                    <ProductName>
                                      {product.ItemName}
                                      <div style={{ lineHeight: "1.0" }}>
                                        <small>MFR Code: {product.mfrCode} {product.variations[0]?.mfrCode}</small>
                                        {/* <br />
                                        <small>Config ID: {product.CONFIGID}</small> */}
                                      </div>
                                    </ProductName>
                                    <ProductColor>
                                      {product.variations.every(
                                        (variation) => variation.ColourName === product.variations[0]?.ColourName
                                      ) && (
                                          <>
                                            {product.ColourID +
                                              "/" +
                                              product.ColourName.replace(/_/g, " ").replace(/\//g, " ")}
                                          </>
                                        )}
                                    </ProductColor>
                                    <ProductSize>
                                      {product.variations_count === 1 && (
                                        <>
                                          {product.SizeID}
                                          <div style={{ lineHeight: "1.0" }}>
                                            <small>Stock: {product.variations[0]?.stocks?.Stock}</small>
                                          </div>
                                        </>
                                      )}
                                    </ProductSize>

                                    <ProductPrice>${product.RetailSalesPrice}</ProductPrice>

                                    <QuantityBox>
                                      {product.variations_count === 1 && (
                                        <>
                                          <IconButton onClick={() => handleSubstract(product.variations[0]?.productID)}>
                                            <Remove />
                                          </IconButton>
                                          <TextField
                                            name="quantity"
                                            type="number"
                                            variant="outlined"
                                            value={
                                              customerDetails.quantity[product.variations[0]?.productID] === 0
                                                ? 0
                                                : customerDetails.quantity[product.variations[0]?.productID] || 1
                                            }
                                            onChange={(e) =>
                                              handleQuantity(
                                                e,
                                                product.variations[0]?.productID,
                                                product.variations[0]?.stocks?.Stock
                                              )
                                            }
                                            style={{ width: "100px" }}
                                          />
                                          <IconButton
                                            onClick={() =>
                                              handleAdd(product.variations[0]?.productID, product.variations[0]?.stocks?.Stock)
                                            }
                                          >
                                            {" "}
                                            <Add />{" "}
                                          </IconButton>
                                        </>
                                      )}
                                    </QuantityBox>

                                    <ButtonDiv>
                                      {product.variations_count !== 1 ? (
                                        <Button
                                          size="medium"
                                          color="primary"
                                          variant="outlined"
                                          onClick={() => handleOpenOptions(product)}
                                        >
                                          View Sizes ({product.variations_count})
                                        </Button>
                                      ) : (
                                        <Button
                                          size="medium"
                                          color="primary"
                                          variant="contained"
                                          disabled={
                                            product.variations[0]?.stocks === null ||
                                            product.variations[0]?.stocks === undefined ||
                                            product.variations[0]?.stocks?.Stock === "0" ||
                                            product.variations[0]?.stocks?.Stock < 0
                                          }
                                          onClick={() =>
                                            handleAddToCart(
                                              product.variations[0]?.productID,
                                              product.SchoolID,
                                              product.ItemName,
                                              product.ColourName,
                                              product.SizeID,
                                              product.ColourID,
                                              product.RetailSalesPrice,
                                              product.imageUrl,
                                              product.WEBSKU
                                            )
                                          }
                                        >
                                          Add To Cart
                                        </Button>
                                      )}
                                    </ButtonDiv>
                                  </ItemsBox>
                                ))}
                              </Grid>
                            ) : (
                              <span>No Products Available</span>
                            )}
                          </div>
                        ))}
                      </>
                    ) : (
                      <span>No Products Available</span>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {customerDetails.cartItems.length === 0 ? (
                  <Cart>Your cart is empty</Cart>
                ) : (
                  <Grid item xs={12}>
                    {customerDetails.cartItems.map((cart, index) => (
                      <ItemsBox key={cart.id}>
                        <ImageBox onClick={() => handleCartImageShow(index)}>
                          {cart.imageUrl ? (
                            <img
                              src={cart.imageUrl}
                              alt={cart.ItemName}
                              onError={handleImageError}
                            />
                          ) : (
                            <img
                              src="https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png"
                              alt="Placeholder"
                            />
                          )}
                        </ImageBox>
                        <ProductName1><b>{cart.ItemName}</b></ProductName1>
                        <ProductColor>{cart.ColourName.replace(/_/g, ' ').replace(/\//g, ' ')}</ProductColor>
                        <ProductCode>{cart.SizeID}</ProductCode>
                        <ProductPrice>${cart.RetailSalesPrice}</ProductPrice>
                        <QuantityBox>
                          {!cart.options && (
                            <>
                              <IconButton onClick={() => handleSubstract(cart.id)}>
                                <Remove />
                              </IconButton>
                              <TextField
                                name="quantity"
                                type="number"
                                variant="outlined"
                                value={
                                  (customerDetails.quantity[cart.id] === 0
                                    ? 0
                                    : customerDetails.quantity[cart.id]) || 1
                                }
                                onChange={(e) => handleQuantity(e, cart.id)}
                                style={{ width: '100px' }}
                              />
                              <IconButton onClick={() => handleAdd(cart.id)}>
                                <Add />
                              </IconButton>
                            </>
                          )}
                        </QuantityBox>
                        <ProductPrice1>
                          Total: ${(parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1)).toFixed(2)}
                        </ProductPrice1>
                        <Tooltip title="Pick Another Size">
                          <PublishedWithChanges
                            sx={{ fontSize: '30px', marginRight: '25px', marginLeft: '10px' }}
                            color="secondary"
                            variant="contained"
                            cursor="pointer"
                            onClick={() => handleOpenOptions(cart)}
                          />
                        </Tooltip>
                        <Tooltip title="Delete">
                          <DeleteForever
                            sx={{ fontSize: '30px' }}
                            color="secondary"
                            variant="contained"
                            cursor="pointer"
                            onClick={() => handleRemoveFromCart(cart.id)}
                          />
                        </Tooltip>
                      </ItemsBox>
                    ))}
                    <ProductPrice2 sx={{ display: 'flex', float: 'right' }}>
                      Sum Total: $
                      {(
                        customerDetails.cartItems.reduce((total, cart) => total + parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1), 0)
                      ).toFixed(2)}
                    </ProductPrice2>
                  </Grid>
                )}
              </>
            )}

            <Grid item xs={12}>
              <Box mt={1} mb={3} textAlign="center">
                <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
                  <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <FormGroup style={{ marginRight: "30px" }}>
                      <FormControlLabel
                        checked={express === true}
                        control={<Switch onChange={handleSwitchChange} />}
                        label={<span style={{ fontFamily: 'Poppins' }}>Express Order</span>}
                      />
                    </FormGroup>

                    {/* <FormGroup>
                      <FormControlLabel
                        checked={payNow === true}
                        control={<Checkbox onChange={handleCheckboxChange} />}
                        label={<span style={{ fontFamily: 'Poppins' }}>Ready to Pay Now</span>}
                      />
                    </FormGroup> */}
                  </div>
                  <ProductPrice2>
                    Sum Total: $
                    {(
                      customerDetails.cartItems.reduce((total, cart) => total + parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1), 0)
                      // (customerDetails.cartItems.reduce((total, cart) => total + parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1), 0) * 0.10)
                    ).toFixed(2)}
                  </ProductPrice2>
                </Box>

                <Button
                  size="large"
                  variant="outlined"
                  color="secondary"
                  onClick={handleReset}
                  sx={{ margin: "10px" }}
                  disabled={keyLoading1 || keyLoading}
                >
                  Cancel Order/Start Again
                </Button>

                <Button
                  size="large"
                  variant="outlined"
                  onClick={() => setStep(2)}
                  sx={{ margin: "10px" }}
                  disabled={keyLoading1 || keyLoading}
                >
                  Choose Another School
                </Button>

                {customerDetails.type === "resume" ? (
                  <React.Fragment>
                    {keyLoading ? (
                      <CircularProgress
                        style={{
                          height: "40px",
                          width: "40px",
                          marginLeft: "10px",
                          position: "relative",
                          top: "20px",
                        }}
                        color="secondary"
                      />
                    ) : (
                      <Button
                        size="large"
                        variant="outlined"
                        //onClick={payNow === true ? handleConfirmSalesOrder : handleUpdateSalesOrder}
                        onClick={handleUpdateSalesOrder}
                        sx={{ margin: "10px" }}
                        disabled={keyLoading1}

                      >
                        Update Sales Order
                      </Button>
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {keyLoading ? (
                      <CircularProgress
                        style={{
                          height: "40px",
                          width: "40px",
                          marginLeft: "10px",
                          position: "relative",
                          top: "20px",

                        }}
                        color="secondary"
                      />
                    ) : (
                      <Button
                        size="large"
                        variant="outlined"
                        //onClick={payNow === true ? handleConfirmSalesOrder : handleSaveSalesOrder}
                        onClick={handleSaveSalesOrder}
                        sx={{ margin: "10px" }}
                        disabled={customerDetails.cartItems.length === 0 || keyLoading1}
                      >
                        Suspend Order
                      </Button>
                    )}
                  </React.Fragment>
                )}
                <React.Fragment>
                  {keyLoading1 ? (
                    <CircularProgress
                      style={{
                        height: "40px",
                        width: "40px",
                        marginLeft: "10px",
                        position: "relative",
                        top: "20px",
                      }}
                      color="secondary"
                    />
                  ) : (
                    <Button
                      size="large"
                      variant="contained"
                      onClick={handleConfirmSalesOrder}
                      sx={{ margin: "10px" }}
                      disabled={!(payNow) || customerDetails.cartItems.length === 0 || keyLoading}

                    >
                      {/* Finish Section & Print */}
                      Complete the order
                    </Button>
                  )}
                </React.Fragment>


              </Box>
            </Grid>
          </Grid>


          <Dialog open={cartOpen} onClose={() => setCartOpen(false)} style={{ minWidth: '800px !important' }} maxWidth="xl">
            <DialogTitle>
              <Box mb={3} textAlign="center">
                <h3>Cart Items</h3>
              </Box>
            </DialogTitle>
            <DialogContent>
              <FsLightbox
                toggler={toggler1}
                //sources={customerDetails.cartItems.map((cart) => cart.imageUrl)}
                sources={cartImageUrls}
                sourceIndex={imageIndex1}
                type="image"

              />

              <div>
                {customerDetails.cartItems.length === 0 ? (
                  <Cart>Your cart is empty</Cart>
                ) : (
                  <ul>
                    {customerDetails.cartItems.map((cart, index) => (
                      <ItemsBox1 key={cart.id}>
                        <ImageBox onClick={() => handleCartImageShow(index)}>
                          {cart.imageUrl ? (
                            <img
                              src={cart.imageUrl}
                              alt={cart.ItemName}
                              onError={handleImageError}
                            />
                          ) : (
                            <img
                              src="https://www.psw.com.au/media/catalog/product/placeholder/default/Image-Coming-Soon.png"
                              alt="Placeholder"
                            />
                          )}
                        </ImageBox>
                        <ProductName1> {state ? <b>{cart.ItemName}</b> : cart.ItemName}</ProductName1>
                        <ProductColor>{cart.ColourName.replace(/_/g, ' ').replace(/\//g, ' ')}</ProductColor>
                        <ProductCode>{cart.SizeID}</ProductCode>
                        <ProductPrice>${cart.RetailSalesPrice}</ProductPrice>
                        <QuantityBox>
                          {!cart.options && (
                            <>
                              <IconButton onClick={() => handleSubstract(cart.id)}>
                                <Remove />
                              </IconButton>
                              <TextField
                                name="quantity"
                                type="number"
                                variant="outlined"
                                value={
                                  (customerDetails.quantity[cart.id] === 0
                                    ? 0
                                    : customerDetails.quantity[cart.id]) || 1
                                }
                                onChange={(e) => handleQuantity(e, cart.id)}
                                style={{ width: '100px' }}
                              />
                              <IconButton onClick={() => handleAdd(cart.id)}>
                                <Add />
                              </IconButton>
                            </>
                          )}
                        </QuantityBox>
                        <ProductPrice1>
                          Total: ${(parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1)).toFixed(2)}
                        </ProductPrice1>

                        <Tooltip title="Pick Another Size">
                          <PublishedWithChanges
                            sx={{ fontSize: '30px', marginRight: '25px', marginLeft: '10px' }}
                            color="secondary"
                            variant="contained"
                            cursor="pointer"
                            onClick={() => handleOpenOptions(cart)}
                          />
                        </Tooltip>
                        <Tooltip title="Delete">
                          <DeleteForever
                            sx={{ fontSize: '30px' }}
                            color="secondary"
                            variant="contained"
                            cursor="pointer"
                            onClick={() => handleRemoveFromCart(cart.id)}
                          />
                        </Tooltip>
                      </ItemsBox1>
                    ))}
                    {/* <ProductPrice1 sx={{ display: 'flex', float: 'right' }}>
                    Sum Total: ${customerDetails.cartItems.reduce(
                      (total, cart) =>
                        total +
                        parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1),
                      0
                    ).toFixed(2)}
                  </ProductPrice1> */}

                    <ProductPrice1 sx={{ display: 'flex', float: 'right' }}>
                      Sum Total: $
                      {(
                        customerDetails.cartItems.reduce((total, cart) => total + parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1), 0)
                        // (customerDetails.cartItems.reduce((total, cart) => total + parseFloat(cart.RetailSalesPrice) * (parseFloat(customerDetails.quantity[cart.id]) || 1), 0) * 0.10)
                      ).toFixed(2)}
                    </ProductPrice1>


                  </ul>
                )}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setCartOpen(false)}>Close</Button>
            </DialogActions>
          </Dialog>


        </Box>
        {openViewOptions && (
          <OptionDialog
            viewOptionDetails={viewOptionDetails}
            singleLoading={singleLoading}
            sendOption={sendOption}
            handleAdd={handleAdd}
            handleSubstract={handleSubstract}
            handleQuantity={handleQuantity}
            handleAddToCart={handleAddToCart}
            customerDetails={customerDetails}
            trigger={trigger}
            setTrigger={setTrigger}
          />
        )}

      </Card>

    </div>

  );
};

export default ProductPage;
